import { createStyles } from '@mantine/core';

export const useFaqStyles = createStyles((theme) => ({}));

export const useFaqScrollAreaStyles = createStyles((theme) => ({
  root: {
    maxHeight: `calc(100svh - 110px)`,
    marginTop: 16,
  },
}));
